<template>
  <div class="multi-line-profile">
    <div v-if="type !== 'password'" class="line-account">
      <cube-input
        v-if="type === 'phone'"
        v-model="account"
        :placeholder="$t('profile.setting.pleaseInput') + $t('profile.setting.phoneNumber')">
      </cube-input>
      <cube-input
        v-else-if="type === 'email'"
        v-model="account"
        :placeholder="$t('profile.setting.pleaseInput') + $t('profile.setting.email')">
      </cube-input>
    </div>
    <div v-if="type !== 'password'" class="line-verification">
      <cube-input
        v-model="verify"
        :placeholder="$t('profile.setting.pleaseInput') + $t('profile.setting.verificationCode')">
        <template v-slot:append>
          <div class="line-verification-suffix">
            <span @click="sendVerify">{{ btntext }}</span>
          </div>
        </template>
      </cube-input>
    </div>
    <div v-if="!_isFeishuClient" class="line-password">
      <cube-input
        v-model="password"
        type="password"
        :placeholder="getPasswordPlaceholder">
      </cube-input>
    </div>
    <div v-if="type === 'password'" class="line-new-password">
      <cube-input
        v-model="newPassword"
        :eye="{ open: false }"
        type="password"
        :placeholder="$t('profile.setting.pleaseInput') + $t('profile.setting.newPassword')">
      </cube-input>
    </div>
    <div class="line-confirm">
      <cube-button @click="handleOk">
        {{ $t('common.common.ok') }}
      </cube-button>
    </div>
  </div>
</template>

<script>
import ParamsCatchMixin from '@/mixin/params-catch.mixin.js'
import { mapState } from 'vuex'
import apis from '../../../api'
import FeishuClientMixin from '@/mixin/feishu-client.mixin'
export default {
  mixins: [ParamsCatchMixin, FeishuClientMixin],
  props: {
    verification: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      type: '',
      account: '',
      password: '',
      verify: '',
      newPassword: '',
      loading: false,
      updating: ''
    }
  },
  computed: {
    ...mapState({
      currentField: (state) => state.profileModule.currentField
    }),
    getPasswordPlaceholder() {
      return this.$t('profile.setting.pleaseInput') +
        (this.type === 'password'
          ? this.$t('profile.setting.originPassword')
          : this.$t('profile.setting.loginPassword'))
    },
    btntext() {
      return this.loading ? this.$t('profile.notice.getting') : this.$t('profile.notice.getVerificationCode')
    }
  },
  created() {
    if (this.currentField) {
      this.type = this.currentField.editType
    }
  },
  methods: {
    validateAccount() {
      if (this.type === 'phone') {
        if (this.account === '') {
          this.$message({
            message: this.$t('profile.setting.phoneNumber') + this.$t('profile.notice.notEmpty'),
            type: 'error'
          })
          return false
        } else if (!/^1[023456789]\d{9}$/.test(this.account)) {
          this.$message({
            message: this.$t('profile.setting.pleaseInput') + this.$t('profile.setting.correct') + this.$t('profile.setting.phoneNumber'),
            type: 'error'
          })
          return false
        }
        return true
      } else {
        if (this.account === '') {
          this.$message({
            message: this.$t('profile.setting.email') + this.$t('profile.notice.notEmpty'),
            type: 'error'
          })
          return false
          // eslint-disable-next-line
        } else if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.account)) {
          this.$message({
            message: this.$t('profile.setting.pleaseInput') + this.$t('profile.setting.correct') + this.$t('profile.setting.email'),
            type: 'error'
          })
          return false
        }
        return true
      }
    },
    handleOk() {
      if (!this.updating) {
        if (this.type === 'phone') {
          this.updatePhone()
        } else if (this.type === 'email') {
          this.updateEmail()
        } else {
          this.updatePassword()
        }
      }
    },
    updatePhone() {
      if (this.validateAccount() && this.verify !== '' && this.password !== '') {
        this.updating = true
        const request = {
          ...apis.PERSONAL_CENTER.UPDATE_PHONE,
          params: {
            phone: this.account,
            phoneCode: this.verify,
            password: this.password
          }
        }
        this.$request(request)
          .asyncThen(
            (resp) => {
              this.updating = false
              this.$router.go(-1)
            },
            () => {
              this.updating = false
            }
          )
          .asyncErrorCatch(() => {
            this.updating = false
          })
      }
    },
    validatePassword() {
      if (this.password === '') {
        this.$message({
          message: this.$t('profile.setting.originPassword') + this.$t('profile.notice.notEmpty'),
          type: 'error'
        })
        return false
      } else if (this.newPassword === '') {
        this.$message({
          message: this.$t('profile.setting.newPassword') + this.$t('profile.notice.notEmpty'),
          type: 'error'
        })
        return false
      } else if (this.password.length < 8) {
        this.$message({
          message: `${this.$t('profile.setting.originPassword')}${this.$t('profile.notice.pwdLength')}`,
          type: 'error'
        })
        return false
      } else if (this.newPassword.length < 8) {
        this.$message({
          message: `${this.$t('profile.setting.newPassword')}${this.$t('profile.notice.pwdLength')}`,
          type: 'error'
        })
        return false
      }
      return true
    },
    updateEmail() {
      if (this.validateAccount() && this.verify !== '' && (this.password !== '' || (this.password === '' && this._isFeishuClient))) {
        this.updating = true
        const request = {
          ...apis.PERSONAL_CENTER.UPDATE_EMAIL,
          params: {
            email: this.account,
            emailCode: this.verify,
            password: this.password
          }
        }
        this.$request(request)
          .asyncThen(
            (resp) => {
              this.updating = false
              this.$router.go(-1)
            },
            () => {
              this.updating = false
            }
          )
          .asyncErrorCatch(() => {
            this.updating = false
          })
      }
    },
    updatePassword() {
      if (this.validatePassword()) {
        const request = {
          ...apis.PERSONAL_CENTER.UPDATE_PASSWORD,
          params: {
            oldPassword: this.password,
            newPassword: this.newPassword
          }
        }
        this.updating = true
        this.$request(request)
          .asyncThen(
            (resp) => {
              this.updating = false
              this.$router.go(-1)
            },
            () => {
              this.updating = false
            }
          )
          .asyncErrorCatch(() => {
            this.updating = false
          })
      }
    },
    sendVerify() {
      if (this.validateAccount()) {
        this.loading = true
        let request
        if (this.type === 'phone') {
          request = {
            ...apis.PERSONAL_CENTER.SEND_SME_CODE,
            params: { type: 'updatePhone', phone: this.account }
          }
        } else {
          request = {
            ...apis.PERSONAL_CENTER.SEND_EMAIL_CODE,
            params: { type: 'updateEmail', email: this.account }
          }
        }
        this.$request(request)
          .asyncThen(
            (resp) => {
              this.loading = false
            },
            () => {
              this.loading = false
            }
          )
          .asyncErrorCatch(() => { this.loading = false })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.multi-line-profile {
  height: 100%;
  background: $--app-body-bgColor;
  padding-top: .571rem;
  .line-account {
    height: 3.143rem;
    padding-left: 1.143rem;
    background: $--app-light-color;
    .cube-input {
      height: 100%;
      &::after {
        border: 0;
        border-bottom: 1px solid $--app-body-bgColor;
      }
    }
  }
  .line-verification {
    height: 3.143rem;
    padding-left: 1.143rem;
    background: $--app-light-color;
    .cube-input {
      height: 100%;
      &::after {
        border: 0;
        border-bottom: 1px solid $--app-body-bgColor;
      }
      .line-verification-suffix {
        color: $--app-primary-color;
        padding-right: 1.143rem;
      }
    }
  }
  .line-password {
    height: 3.143rem;
    padding-left: 1.143rem;
    background: $--app-light-color;
    .cube-input {
      height: 100%;
      &::after {
        border: 0;
        border-bottom: 1px solid $--app-body-bgColor;
      }
    }
  }
  .line-new-password {
    height: 3.143rem;
    padding-left: 1.143rem;
    background: $--app-light-color;
    .cube-input {
      height: 100%;
      &::after {
        border: 0;
        border-bottom: 1px solid $--app-body-bgColor;
      }
    }
  }
  .line-confirm {
    padding: .571rem 1.143rem;
    .cube-btn {
      height: 2.857rem;
      background: $--app-primary-color;
    }
  }
}
</style>

<style lang="scss">
.multi-line-profile {
  .line-account {
    .cube-input {
      .cube-input-field {
        padding-left: 0;
      }
    }
  }
  .line-verification {
    .cube-input {
      .cube-input-field {
        padding-left: 0;
      }
    }
  }
  .line-password {
    .cube-input {
      .cube-input-field {
        padding-left: 0;
      }
    }
  }
  .line-new-password {
    .cube-input {
      .cube-input-field {
        padding-left: 0;
      }
    }
  }
}
</style>
